export enum DeliveryOptionEnum {
    PICKUP = 1,
    SHIPPING = 2
}
